import { render } from "./GeneralsMultititlePage.vue?vue&type=template&id=5cd33739"
import script from "./GeneralsMultititlePage.vue?vue&type=script&lang=js"
export * from "./GeneralsMultititlePage.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__